<!--  -->
<template>
  <div class="WorkM_HeaderMene">
    <div class="hamburger-menu w-35" v-b-toggle.sidebar-1><b-icon icon="menu-button-wide"></b-icon></div>
    <div class="WorkM_HeaderMeneTitle w-30">{{ dispTitle }}</div>
    <div class="w-35 text-right">
      <div style="font-size: 0.8rem">{{ loginUserName }}</div>
      <div style="font-size: 0.7rem">{{ loginUserId }}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "HeaderMene",
  props: {
    value: {},
    companyName: {type: String, default: ""},
  },
  data: function () {
    // return {};
    return {
      loginUserId: null,
      loginUserName: null
    };
  },
  computed: {
    inputedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    dispTitle: function () {
      let path = this.$route.path;
      if (path == "/Home") {
        return "ホーム";
      } else if (path == "/WorkRegist") {
        return "報告";
      } else if (path == "/WorkCalendar") {
        return "カレンダー";
      } else if (path == "/ApplicationRegist") {
        return "事前申請";
      } else if (path == "/ApplicationHistory") {
        return "承認状況";
      } else if (path == "/Approval") {
        return "承認";
      } else if (path == "/ApprovalHistory") {
        return "承認履歴";
      } else if (path == "/AttendanceCheck") {
        return "在席確認";
      } else if (path == "/WorkState") {
        return "勤務状況";
      } else {
        return "";
      }
    },
  },
  mounted: function () {
      this.loginUserId = this.$store.state.user_id;
      this.loginUserName = this.$store.state.user_name;
  },
  methods: {},
};
</script>

<style>
.WorkM_HeaderMene {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--mainColor);
  color: white;
  padding: 0.5rem 1rem;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.hamburger-menu {
  color: white;
  font-size: 1rem;
  cursor: pointer;
}
.hamburger-menu:hover {
  color: rgb(238, 238, 238);
}

.WorkM_HeaderMeneTitle {
  flex-grow: 1;
  text-align: center;
  padding: 0;
}
</style>
